import { BaseError } from "./base-error.js";
export var GuardrailErrorCode;
(function (GuardrailErrorCode) {
    GuardrailErrorCode["GeneralError"] = "GENERAL_ERROR";
    GuardrailErrorCode["InvalidData"] = "INVALID_DATA";
    GuardrailErrorCode["InvalidResponse"] = "INVALID_RESPONSE";
    GuardrailErrorCode["SchemaError"] = "SCHEMA_ERROR";
    GuardrailErrorCode["SchemaVersionMismatch"] = "SCHEMA_VERSION_MISMATCH";
    GuardrailErrorCode["NotEntitled"] = "NOT_ENTITLED";
})(GuardrailErrorCode || (GuardrailErrorCode = {}));
export class GuardrailError extends BaseError {
    constructor(message = 'Guardrail error.', options = { code: GuardrailErrorCode.GeneralError }) {
        const { code, reportToSentry, originalError } = options;
        super(message, {
            reportToSentry,
            extensions: {
                code,
                originalError
            }
        });
    }
}
